import { Cell, Grid, TextField } from 'bold-ui'
import React from 'react'

export interface HistoricoEvolucoesOdontoTableHeaderProps {
  onChangeFilter(filter: string): void
}

export function HistoricoEvolucoesOdontoTableHeader(props: HistoricoEvolucoesOdontoTableHeaderProps) {
  const { onChangeFilter } = props

  return (
    <Grid alignItems='flex-start' gap={1}>
      <Cell md={7} lg={6}>
        <TextField
          placeholder='Pesquise por procedimento, local ou profissional'
          icon='zoomOutline'
          onChange={(e) => onChangeFilter(e.currentTarget.value)}
        />
      </Cell>
    </Grid>
  )
}
